import styled from 'styled-components'

export const Page = styled.div`
  display: grid;
  ${({ isBigScreen }) => (isBigScreen ? 'grid-template-columns: 225px calc(100% - 225px);' : '')}
  
  /* grid-template-columns: max(200px, 15%) 1fr; */
  width: 100%;
  min-height: 91vh;
`
